// src/utils/permissionHelper.js
/**
 * Pure permission helper functions.
 * These operate on a user object returned from the backend profile endpoint.
 * No reliance on role strings or legacy fields.
 */

/**
 * Check if the user has a specific permission.
 * @param {Object} user - Authenticated user object.
 * @param {string} permission - Permission name to verify.
 * @returns {boolean}
 */
export const hasPermission = (user, permission) => {
  if (!permission) return true; // No permission required
  if (!user) return false;
  // Super admin / Vendor owner bypass (primary restaurant owner has full access)
  if (user.is_super_admin || user.role === 'vendor' || user.role === 'admin') return true;
  const perms = user.permissions || [];
  return perms.includes(permission);
};

/**
 * Check if the user has ANY of the supplied permissions.
 * @param {Object} user
 * @param {string[]} permissions
 * @returns {boolean}
 */
export const hasAnyPermission = (user, permissions = []) =>
  permissions.some(p => hasPermission(user, p));

/**
 * Check if the user has ALL of the supplied permissions.
 * @param {Object} user
 * @param {string[]} permissions
 * @returns {boolean}
 */
export const hasAllPermissions = (user, permissions = []) =>
  permissions.every(p => hasPermission(user, p));
